module.exports = __webpack_public_path__ + "static/KrestonMetroNerd-b7e794165315d28299a87a82aaefbae0.png";